var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"descriptions__searchInput"},[_c('img',{attrs:{"src":require("../../../assets/images/search.svg"),"alt":"search"}}),_c('input',{attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }